import initialState from "./initialState"; // These are for SETSCHEDULE action, if we can move the logic somewhere else, make sure to move these too

import newAvailability from "../helpers/calendarHelpers/newAvailability";
import getEvents from "../helpers/calendarHelpers/getEvents";
import getNewGroup from "../helpers/calendarHelpers/getNewGroup";
import { uuid } from 'uuidv4';
/**
 * Faster scheduling reducer
 *
 * @param {import('./store').FasterSchedulingState} state
 * @param {import('./store').IFasterSchedulingActions} action
 */

let fasterSchedulingReducer = (state = initialState, action) => {
  switch (action.type) {
    // only use UPDATE to update state
    case 'UPDATE':
      const {
        payload
      } = action; // console.log(payload, state)

      return { ...state,
        ...payload
      };
    // TODO: does the logic have to live here?
    // TODO: rewrite this if possible
    // What this function seems to do: Update the availabilities in the schdedule state. Other value in schedule seems to stay the same from input to output
    // Ideally we do this without using multi-dimensional loops and control the numbers of if conditions

    case 'SETSCHEDULE':
      const {
        schedule
      } = action.payload; // eslint-disable-next-line

      console.log(schedule);
      const clientAv = getEvents(schedule, 'client');
      const expertAv = getEvents(schedule, 'expert');
      const typeArr = ['client', 'expert'];
      const events = [clientAv, expertAv];
      const returnArr = [];
      let idArr = []; // Default to the schedule send to this reducer

      let newState = { ...state,
        schedule
      };

      const reduceOnce = () => {
        // i will only be 0 and 1
        for (let i = 0; i < typeArr.length; i++) {
          if (events[i].length !== 0) {
            // Loop through the same array?
            events[i].forEach(event => {
              events[i].forEach(current => {
                const curGroup = current.raw.group ? current.raw.group : [];
                const evGroup = event.raw.group ? event.raw.group : [];
                const groupArr = [...curGroup, ...evGroup];

                if (event.id === current.id) {
                  return;
                } else if (current.start >= event.start && current.end <= event.end) {
                  returnArr.push(newAvailability(typeArr[i], new Date(event.start).getTime(), new Date(event.end).getTime(), groupArr));
                  idArr.push(event.id, current.id);
                  return;
                } else if (current.start <= event.start && current.end <= event.end && current.start < event.end && event.start < current.end) {
                  returnArr.push(newAvailability(typeArr[i], new Date(current.start).getTime(), new Date(event.end).getTime(), groupArr));
                  idArr.push(current.id, event.id);
                  return;
                } else if (new Date(event.end).getTime() === new Date(current.start).getTime()) {
                  returnArr.push(newAvailability(typeArr[i], new Date(event.start).getTime(), new Date(current.end).getTime(), groupArr));
                  idArr.push(current.id, event.id);
                  return;
                } else {
                  return;
                }
              });
            });
          }
        }
      }; // Populate returnArr and idArr


      reduceOnce();
      const returnArrClient = returnArr.filter(x => x.type === 'client');
      const returnArrExpert = returnArr.filter(x => x.type === 'expert'); // TODO: Dont like this, but not sure how to change this

      const clientAvailabilityLongerThanOne = returnArrClient.length > 1;
      const expertAvailabilityLongerThanOne = returnArrExpert.length > 1;
      const exactlyOneClientAvailability = returnArrClient.length === 1;
      const exactlyOneExpertAvailability = returnArrExpert.length === 1; // TODO: Find common pattern and reduce repetitive code

      if (clientAvailabilityLongerThanOne && expertAvailabilityLongerThanOne) {
        const newArrClient = schedule.availabilities.filter(avb => !idArr.includes(avb.id) && avb.type === 'client');
        const newArrExpert = schedule.availabilities.filter(avb => !idArr.includes(avb.id) && avb.type === 'expert');
        const outClient = schedule.availabilities.filter(avb => idArr.includes(avb.id) && avb.type === 'client');
        const outExpert = schedule.availabilities.filter(avb => idArr.includes(avb.id) && avb.type === 'expert');
        const newClientGroup = getNewGroup(outClient);
        const newExpertGroup = getNewGroup(outExpert);
        const newClient = {
          type: 'client',
          id: uuid(),
          time: {
            start: Math.min(...outClient.filter(o => o.type === 'client').map(o => o.time.start)),
            end: Math.max(...outClient.filter(o => o.type === 'client').map(o => o.time.end))
          },
          raw: {
            group: newClientGroup
          }
        };
        const newExpert = {
          type: 'expert',
          id: uuid(),
          time: {
            start: Math.min(...outExpert.filter(o => o.type === 'expert').map(o => o.time.start)),
            end: Math.max(...outExpert.filter(o => o.type === 'expert').map(o => o.time.end))
          },
          raw: {
            group: newExpertGroup
          }
        };
        const result = [...newArrClient, ...newArrExpert, newClient, newExpert];
        newState = { ...state,
          schedule: { ...state.schedule,
            availabilities: result,
            timeslots: schedule.timeslots
          }
        };
      } else if (clientAvailabilityLongerThanOne && exactlyOneExpertAvailability) {
        const newArr = schedule.availabilities.filter(avb => !idArr.includes(avb.id));
        const outClient = schedule.availabilities.filter(avb => idArr.includes(avb.id) && avb.type === 'client');
        const newClientGroup = getNewGroup(outClient);
        const newClient = {
          type: 'client',
          id: uuid(),
          time: {
            start: Math.min(...outClient.filter(o => o.type === 'client').map(o => o.time.start)),
            end: Math.max(...outClient.filter(o => o.type === 'client').map(o => o.time.end))
          },
          raw: {
            group: newClientGroup
          }
        };
        const result = [...newArr, ...returnArrExpert, newClient];
        newState = { ...state,
          schedule: { ...state.schedule,
            availabilities: result,
            timeslots: schedule.timeslots
          }
        };
      } else if (expertAvailabilityLongerThanOne && exactlyOneClientAvailability) {
        const newArr = schedule.availabilities.filter(avb => !idArr.includes(avb.id));
        const outExpert = schedule.availabilities.filter(avb => idArr.includes(avb.id) && avb.type === 'expert');
        const newExpertGroup = getNewGroup(outExpert);
        const newExpert = {
          type: 'expert',
          id: uuid(),
          time: {
            start: Math.min(...outExpert.filter(o => o.type === 'expert').map(o => o.time.start)),
            end: Math.max(...outExpert.filter(o => o.type === 'expert').map(o => o.time.end))
          },
          raw: {
            group: newExpertGroup
          }
        };
        const result = [...newArr, ...returnArrClient, newExpert];
        newState = { ...state,
          schedule: { ...state.schedule,
            availabilities: result,
            timeslots: schedule.timeslots
          }
        };
      } else if (clientAvailabilityLongerThanOne) {
        const newArr = schedule.availabilities.filter(avb => !idArr.includes(avb.id));
        const outClient = schedule.availabilities.filter(avb => idArr.includes(avb.id) && avb.type === 'client');
        const newClientGroup = getNewGroup(outClient);
        const newClient = {
          type: 'client',
          id: uuid(),
          time: {
            start: Math.min(...outClient.filter(o => o.type === 'client').map(o => o.time.start)),
            end: Math.max(...outClient.filter(o => o.type === 'client').map(o => o.time.end))
          },
          raw: {
            group: newClientGroup
          }
        };
        const result = [...newArr, newClient];
        newState = { ...state,
          schedule: { ...state.schedule,
            availabilities: result,
            timeslots: schedule.timeslots
          }
        };
      } else if (expertAvailabilityLongerThanOne) {
        const newArr = schedule.availabilities.filter(avb => !idArr.includes(avb.id));
        const outExpert = schedule.availabilities.filter(avb => idArr.includes(avb.id) && avb.type === 'expert');
        const newExpertGroup = getNewGroup(outExpert);
        const newExpert = {
          type: 'expert',
          id: uuid(),
          time: {
            start: Math.min(...outExpert.filter(o => o.type === 'expert').map(o => o.time.start)),
            end: Math.max(...outExpert.filter(o => o.type === 'expert').map(o => o.time.end))
          },
          raw: {
            group: newExpertGroup
          }
        };
        const result = [...newArr, newExpert];
        newState = { ...state,
          schedule: { ...state.schedule,
            availabilities: result,
            timeslots: schedule.timeslots
          }
        };
      } else if (exactlyOneClientAvailability || exactlyOneExpertAvailability) {
        const newArr = schedule.availabilities.filter(avb => !idArr.includes(avb.id));
        const result = [...newArr, ...returnArr];
        newState = { ...state,
          schedule: { ...state.schedule,
            availabilities: result,
            timeslots: schedule.timeslots
          }
        };
      }

      return newState;

    case 'SETADDEXPERTSADDED':
      return { ...state,
        expertsAdded: [...state.expertsAdded, action.payload]
      };

    case 'SETREMOVEEXPERTSADDED':
      return { ...state,
        expertsAdded: state.expertsAdded.filter(model => // @ts-ignore
        model.epl.expert.fullName !== action.payload.epl.expert.fullName)
      };

    default:
      return state;
  }
};

if (window.location.search.includes('debug=')) {
  let reducer = fasterSchedulingReducer;

  fasterSchedulingReducer = (s, a) => {
    // eslint-disable-next-line no-console
    console.group('FS STATE UPDATE:', a.type); // eslint-disable-next-line no-console

    console.log('STATE', s); // eslint-disable-next-line no-console

    console.log('ACTION', a);
    const res = reducer(s, a); // eslint-disable-next-line no-console

    console.log('NEW STATE', res); // eslint-disable-next-line no-console

    console.groupEnd();
    return res;
  };
}

export { fasterSchedulingReducer };